import { Form, Button, Row, Col } from 'react-bootstrap';

const UpdateQuestionForm = ({ updatedQuestion, setUpdatedQuestion, handleSubmit }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedQuestion((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...updatedQuestion.options];
    newOptions[index] = value;
    setUpdatedQuestion((prev) => ({
      ...prev,
      options: newOptions,
    }));
  };

  const addOption = () => {
    setUpdatedQuestion((prev) => ({
      ...prev,
      options: [...prev.options, ''],
    }));
  };

  const removeOption = (index) => {
    const newOptions = [...updatedQuestion.options];
    newOptions.splice(index, 1);
    setUpdatedQuestion((prev) => ({
      ...prev,
      options: newOptions,
    }));
  };

  return (
    <Form 
        className='d-flex flex-column justify-content-center align items-center w-50'
        onSubmit={(e) => handleSubmit(e)}
    >
      <Form.Group controlId="questionText" className="mb-3">
        <Form.Label className="fs-4 text-center w-100">Question</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Enter question"
          name="question"
          value={updatedQuestion.question}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Label className="fs-4 text-center w-100">Options</Form.Label>
      {updatedQuestion.options.map((opt, idx) => (
        <Row className="mb-2" key={idx}>
          <Col xs={10}>
            <Form.Control
              type="text"
              placeholder={`Option ${idx + 1}`}
              value={opt}
              onChange={(e) => handleOptionChange(idx, e.target.value)}
            />
          </Col>
          <Col xs={2}>
            <Button variant="danger" onClick={() => removeOption(idx)}>-</Button>
          </Col>
        </Row>
      ))}
      <Button variant="secondary" className="mb-3" onClick={addOption}>
        Add Option
      </Button>

      <Form.Group controlId="correctAnswer" className="mb-3">
        <Form.Label className="fs-4 text-center w-100">Correct Answer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter correct answer"
          name="correct_answer"
          value={updatedQuestion.correct_answer}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group controlId="explanation" className="mb-3">
        <Form.Label className="fs-4 text-center w-100">Explanation</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Enter explanation"
          name="explanation"
          value={updatedQuestion.explanation}
          onChange={handleChange}
        />
      </Form.Group>

      <Button type="submit" className='quiz-btn'>
        Update Question
      </Button>
    </Form>
  );
};

export default UpdateQuestionForm;
